import React, { useEffect, useState } from "react";
import Api from "utils/services/Api";
import EndPoints from "utils/services/EndPoints";
import { Grid } from "@mui/material";
import Table from "components/Tabla/Table";
import { getCodigoIfip } from "utils/Common";
import { useSnackbar } from "notistack";

export const ListCuenta = ({
  codigoSocio,
}) => {
  const [loading, setLoading] = useState(true);
  const [listadoCuentas, setListadoCuentas] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    let isMounted = true

    const fetchData = async () => {
      try {
        const response = await Api(`${EndPoints.listadoCuentas}/${codigoSocio}/${getCodigoIfip()}`,
          "GET",
          null
        )
        if (isMounted) {
          setListadoCuentas(response);
          setLoading(false);
        }
      } catch (error) {
        enqueueSnackbar(error.message, { variant: "error" })
      }
    }

    fetchData();

    return () => {
      isMounted = false
    }
  }, [codigoSocio, enqueueSnackbar]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Table
          id={listadoCuentas.codigo}
          title=""
          columns={[
            {
              title: "CODIGO",
              field: "codigo",
              width: 10
            },
            {
              title: "TIPO CUENTA",
              field: "productoMs.descripcion",
              width: 50,
            },
            {
              title: "NUMERO CUENTA",
              field: "numeroCuenta",
              width: 50,
            },
          ]}
          data={listadoCuentas}
          maxHeight="400px"
          loading={loading}
        />
      </Grid>
    </Grid>
  );
};

export default ListCuenta;
